<template>
    <v-container fluid px-3 pt-3>
        <v-row>
            <v-col>
                <h3>User Profile</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
        <v-skeleton-loader v-if="$auth.loading" type="card" loading="true" ></v-skeleton-loader>
        <!-- <v-progress-circular indeterminate color="primary" :size="100" :width="15" :rotate="360"></v-progress-circular> -->

        <template v-if="!$auth.loading && $auth.isAuthenticated">
            <v-row v-if="$auth.user && !$auth.user.email_verified">
                <v-col>
                    <v-alert type="error" :value="true">
                        You have not validated your account email address.  You cannot use this system until your account email address is validated.
                    </v-alert>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col v-if="!vssUserDto">
                    <v-alert type="error" :value="true">
                        There was an error loading your user profile.  Please log out and log in to this system at a later time.
                    </v-alert>
                </v-col>
                <v-col v-if="vssUserDto && !(hasRoles)">
                    <v-alert type="warning" :value="vssUserDto.isActive">
                        You user roles have not been set up yet.  You cannot use this system until your user roles have been set up by the Administrator.
                    </v-alert>
                    <v-alert type="warning" :value="!vssUserDto.isActive">
                        Your user is inactive.  You cannot use this system.
                    </v-alert>
                </v-col>
                <v-col v-if="vssUserDto && hasRoles">
                    <v-card>
                        <v-toolbar prominent flat color="grey lighten-2">
                            <v-col style="display:inline-flex;">
                                <div class="v-avatar">
                                    <v-img :src="userProfilePicUrl" alt="avatar" max-height="80" max-width="80" contain></v-img>
                                </div>
                                <h2 style="margin-left: 20px;">{{userName}}</h2>
                            </v-col>
                        </v-toolbar>
                        <v-card-text>
                            <v-row class="h4">
                                <v-col cols="12" sm="5" md="3">Name:</v-col>
                                <v-col cols="12" sm="7" md="9">{{userName}}</v-col>
                            </v-row>
                            <v-row class="h4">
                                <v-col cols="12" sm="5" md="3">Email:</v-col>
                                <v-col cols="12" sm="7" md="9">{{userEmail}}</v-col>
                            </v-row>
                            <v-row class="h4">
                                <v-col cols="12" sm="5" md="3">Roles:</v-col>
                                <v-col cols="12" sm="7" md="9">{{userRoleListText}}</v-col>
                            </v-row>
                            <v-row class="h4">
                                <v-col cols="12">
                                    <v-btn @click="goToSetup()">User Setup</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'
import userService from '@/services/userService'

export default {
    data () {
        return {
        }
    },
    computed: {
        ...mapState('auth', ['vssUserDto']),
        userName: function () {
            return (this.$auth.user && this.$auth.user.name) ? this.$auth.user.name : 'Unknown User'
        },
        userProfilePicUrl: function () {
            return (this.$auth.user && this.$auth.user.picture) ? this.$auth.user.picture : ''
        },
        userEmail: function () {
            return (this.$auth.user && this.$auth.user.email) ? this.$auth.user.email : ''
        },
        isAdmin: function () {
            return (this.vssUserDto && userService.isAdministrator())
        },
        hasRoles: function () {
            return (this.vssUserDto && userService.hasRoleList())
        },
        userRoleListText: function () {
            return (this.hasRoles) ? this.vssUserDto.roleList.join(', ') : 'No Roles Assigned'
        }
    },
    methods: {
        goToSetup () {
            this.$router.push('user-setup')
        }
    }
}
</script>
